import classNames from 'classnames';
import styled from 'styled-components';
import { GroupPersonality } from 'Types/GroupsTypes';
import { dummyCompanyPluse } from 'Utils/UtilityFunctions';
import {
  maxWidth, retina,
} from '../../../Utils/utilsStyle';
import CompanyHoloSvg from '../assets/holoSvgIcon/CompanyHoloSvg';

export type WidgetProps = {
  diameter?: string,
  diameterSm?: string,
  diameterL?: string,
  ringPosition?: string,
  ringSize?: string,
  wrapperColor?: string;
  logo: string,
  ringPaddingSm?: string,
  companyHoloColors?: GroupPersonality[],
} & typeof defaultProps;

const defaultProps = {
  diameter: '210px',
  diameterSm: '240px',
  diameterL: '300px',
  ringPosition: 'center',
  ringSize: 'cover',
  wrapperColor: '#979797',
  ringPaddingSm: '4px',
  companyHoloColors: [
    {
      color: '',
      end: '',
      percentage: 0,
      start: '0%',
    },
  ],
};

const Wrapper = styled.div<{ ringPaddingSm: string, color: string }>`
 height: 100%;
 width: 100%;
 border-radius: 50%;
 display: flex;
 justify-content: center;
 align-items: center;
 background: conic-gradient(from -280deg, ${(props) => props.color});
 background-color: ${(props) => props.color};
 &.twoColorPersonalityRing {
  background: linear-gradient(-300deg, ${(props) => props.color});
 }
 &.threeColorPersonalityRing {
   background: conic-gradient(from -280deg, ${(props) => props.color});
 }
`;

const Image = styled.div<{ image: string, ringSize: string, ringPosition: string, }>`
 border-radius: 50%;
 background-image: url(${(props) => props.image});
 background-color: #fff;
 background-repeat: no-repeat;
 background-position: ${(props) => props.ringPosition};
 background-size: ${(props) => props.ringSize};
 height: 95%;
 width: 95%;
 border: 2px solid #fff;
`;

const HoloHolder = styled.div<{ diameter: string, diameterSm: string, diameterL: string }>`
  height: ${(props) => props.diameterL};
  width: ${(props) => props.diameterL};
  min-width: ${(props) => props.diameterL};
  margin: -20px;
  margin-left: 0px !important;
  margin-right: 0px !important;
  position: relative;

  @media all and (max-width: ${maxWidth}) , ${retina} {
    height: ${(props) => props.diameter};
    width: ${(props) => props.diameter};
    min-width: ${(props) => props.diameter};
    margin: -15px;
  }

  @media all and (min-width: 1500px) {
    width: ${(props) => props.diameterSm};
    height: ${(props) => props.diameterSm};
    min-width: ${(props) => props.diameterSm};
    margin: 0px;
  }

  .holo-svg {
    height: 100%;
    width: 100%;
    min-width: 100%;
    &.less-then-two-color {
      transform: rotate(-40deg);
    }
  }

  .company-item-widget {
    border-radius: 50%;
    margin: 0px 3px 0px 3px;
    position: absolute;
    transform: translate(-51%,-52%);
    width: 83%;
    height: 83%;
    min-width: 83%;
    top: 50%;
    left: 50%;
    @media all and (max-width: 1500px) {
      transform: translate(-50%,-51%);
    }
    &.rotateCircle {
    transform: translate(-51%,-51%);
    width: 84%;
    height: 84%;
    min-width: 84%;
    top: 54%;
    left: 49%;
    }
  }
`;

const CompanyWidgetWithHolo = function CompanyWidgetWithHolo(props: WidgetProps) {
  const {
    diameter, diameterSm, logo, diameterL,
    wrapperColor, ringPosition, ringSize, ringPaddingSm, companyHoloColors,
  } = props;

  return (
    <HoloHolder
      diameter={diameter}
      diameterSm={diameterSm}
      diameterL={diameterL}
      className="company-widget-holo-holder"
    >
      <CompanyHoloSvg
        companyHoloColors={companyHoloColors.length > 0 ? companyHoloColors : dummyCompanyPluse()}
      />
      <div className={classNames('company-item-widget', {
        rotateCircle: companyHoloColors.length > 2,
      })}
      >
        <Wrapper
          color={wrapperColor}
          ringPaddingSm={ringPaddingSm}
          className={classNames({
            twoColorPersonalityRing: companyHoloColors.length === 2,
            threeColorPersonalityRing: companyHoloColors.length === 3,
          })}
        >
          <Image
            image={logo}
            ringPosition={ringPosition}
            ringSize={ringSize}
          />
        </Wrapper>
      </div>
    </HoloHolder>

  );
};
CompanyWidgetWithHolo.defaultProps = defaultProps;
export default CompanyWidgetWithHolo;
